var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgBrowserMenuArrow = function SvgBrowserMenuArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 60,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E7E7EC",
    d: "M0 60c15.37-9.955 24.522-26.496 26.28-46.358 1.487-.01 2.233-.014 3.72-.029C27.323 8.596 24.31 4 20.491 0c-1.517 4.914-3.387 9.614-6.245 13.74 1.487-.01 2.233-.02 3.72-.03C19.09 32.121 12.564 48.317 0 60"
  })));
};
var Memo = /*#__PURE__*/memo(SvgBrowserMenuArrow);
export default Memo;